import React from 'react';
import notfound from '../Images/notfound.gif'
import './Notfound.css'
const Notfound = () => {
    return (
        <div>
            <img src={notfound} alt="nothing found" />

        </div>
    );
};

export default Notfound;